module.exports = __webpack_public_path__ + "assets/svg/Icons/32/task-green-14adeb.svg";